// Generate website JSON-LD
export const generateWebsiteJsonLd = (
  name = 'X-SPACE Real Estate Dubai',
  url = 'https://x-space.ae',
  includeSearchBox = true
) => {
  const jsonLd = {
    '@type': 'WebSite',
    name,
    url,
  };

  if (includeSearchBox) {
    jsonLd.potentialAction = {
      '@type': 'SearchAction',
      target: `${url}/properties/search?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    };
  }

  return jsonLd;
};

// Generate organization JSON-LD
export const generateOrganizationJsonLd = (
  name = 'X-SPACE Real Estate',
  url = 'https://x-space.ae',
  logo = 'https://images.x-space.ae/assets/images/Logo-B.png',
  socialLinks = []
) => {
  return {
    '@type': 'Organization',
    name,
    url,
    logo,
    sameAs: socialLinks,
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Dubai',
      addressLocality: 'Dubai',
      postalCode: '00000',
      addressCountry: 'AE',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+971-4-3965199',
      contactType: 'customer service',
    },
  };
};

// Generate breadcrumb JSON-LD
export const generateBreadcrumbJsonLd = (items) => {
  return {
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
};

// Generate real estate listing JSON-LD
export const generateRealEstateListingJsonLd = (property) => {
  const jsonLd = {
    '@type': 'RealEstateListing',
    name: property.name,
    description: property.description,
    image: property.image,
    url: property.url,
  };

  if (property.price) {
    jsonLd.offers = {
      '@type': 'Offer',
      price: property.price,
      priceCurrency: property.currency || 'AED',
      availability: 'https://schema.org/InStock',
    };
  }

  if (property.address) {
    jsonLd.address = {
      '@type': 'PostalAddress',
      streetAddress: property.address,
      addressLocality: property.city || 'Dubai',
      addressCountry: property.country || 'AE',
    };
  }

  if (property.bedrooms) {
    jsonLd.numberOfRooms = property.bedrooms;
  }

  if (property.area) {
    jsonLd.floorSize = {
      '@type': 'QuantitativeValue',
      value: property.area,
      unitCode: 'SQFT',
    };
  }

  return jsonLd;
};

// Generate local business JSON-LD
export const generateLocalBusinessJsonLd = () => {
  return {
    '@type': 'RealEstateAgent',
    name: 'X-SPACE Real Estate',
    image: 'https://images.x-space.ae/assets/images/Logo-B.png',
    '@id': 'https://x-space.ae',
    url: 'https://x-space.ae',
    telephone: '+971-4-3965199',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Dubai',
      addressLocality: 'Dubai',
      postalCode: '00000',
      addressCountry: 'AE',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 25.1857187,
      longitude: 55.3720988,
    },
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        opens: '09:30',
        closes: '18:30',
      },
    ],
    priceRange: '$$',
  };
};
